import Alpine from 'alpinejs'

export const initAlpine = () => {
  
  window.Alpine = Alpine
  
  Alpine.start()

}

export default () => {}